import React, { useEffect } from "react";
import GPAC from "../images/corner/corner-gpac.webp";
import { renderStrapiContent } from "../utils/contentfulOptions";
import FullPageLoader from "../components/FullPageLoader";

const Sustainability = ({ info }) => {
  useEffect(() => {
    document.title = "Auburn Road - Sustainability";
    return () => {
      document.title = "Auburn Road Vineyards";
    };
  }, []);

  if (!info) {
    return <FullPageLoader />;
  }

  return (
    <>
      <img className="corner-gpac" src={GPAC} alt="" />
      <div className="container content-page p-t-100">
        <section className="content-hero">
          <p className="content-hero__kicker">Land & legacy</p>
          <h1 className="huge-text-no-quote content-hero__title">
            Sustainability
          </h1>
          <p className="content-hero__intro">
            Our commitment to farming, community, and the long life of this
            land.
          </p>
        </section>

        <section className="content-story content-story--copy-only">
          <div className="content-story__copy">
            {renderStrapiContent(info.content)}
          </div>
        </section>
      </div>
    </>
  );
};

export default Sustainability;
